import { Badge } from "@components/shadcn-ui/badge";
import { Eye } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { Task } from "../types";
import { getStatusColor } from "../../applications/config";
import {getResourcePath} from "@lib/utils";

export const MobileTaskCard = ({ tasks }: { tasks: Task[] }) => {
    const navigate = useNavigate();

    return (
        <div className="flex flex-col gap-1 md:hidden overflow-auto">
            {tasks.map((task) => (
                <div>
                    <div className="bg-white p-3 rounded-lg shadow-sm border mb-2">
                        {/* Header: Status and View Button */}
                        <div className="flex justify-between items-center mb-2">
                            <h3 className="font-semibold max-w-[200px] truncate">{task.title}</h3>
                            <Link
                                to={`${getResourcePath(task)}/${task.resourceId}/tasks/${task.taskId}`}
                                className="text-gray-600 hover:text-black"
                            >
                                <Eye className="h-4 w-4"/>
                            </Link>
                        </div>

                        {/* Main Content */}
                        <div className="grid grid-cols-2 gap-2 text-sm">
                            <div>
                                <p className="text-gray-500 text-xs">Assignee</p>
                                <p className="font-medium truncate" title={task.assignee}>
                                    {task.assignee}
                                </p>
                            </div>
                            <div>
                                <p className="text-gray-500 text-xs">Author</p>
                                <p className="font-medium truncate" title={task.author}>
                                    {task.author}
                                </p>
                            </div>
                            <div>
                                <p className="text-gray-500 text-xs">Due Date</p>
                                <p className="font-medium">
                                    {new Date(task.dueDateInUTCEpoch).toLocaleDateString()}
                                </p>
                            </div>
                            <div>
                                <p className="text-gray-500 text-xs">Priority</p>
                                <p className="font-medium" title={task.author}>
                                    {task.priority}
                                </p>
                            </div>
                            <div>
                                <p className="text-gray-500 text-xs">ApplicationId</p>
                                <p className="font-medium" title={task.resourceId}>
                                    <a href={`${getResourcePath(task)}/${task.resourceId}`}>{task.resourceId}</a></p>
                            </div>
                            <div>
                                <p className="text-gray-500 text-xs">Status</p>
                                <Badge className={`rounded-sm px-2 text-xs ${getStatusColor(task.status)}`}>
                                    {task.status.replace('_', ' ')}
                                </Badge>
                            </div>
                            <div>
                                <p className="text-gray-500 text-xs">Type</p>
                                <p className="font-medium" title={task.type}>
                                    {task.type}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};